import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { DateSchema, EquivalentSecurityListId, SecurityId, } from "../../Types";
import ValidationError from "../../ZodError";
const Member = z.object({
    securityId: SecurityId,
});
export const EquivalentSecurityList = z.object({
    listId: EquivalentSecurityListId,
    deleted: z.boolean(),
    name: z.string(),
    description: z.string(),
    listVersion: z.number(),
    createdAt: DateSchema,
    updatedAt: DateSchema,
    members: Member.array(),
});
const Response = EquivalentSecurityList;
export const url = (listId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/equivalentsecurities/${listId}`
    : `https://middleware.uat.farther.com/equivalentsecurities/${listId}`;
export default async function getEquivalentSecurityList(listId, config) {
    const { data } = await axios.get(url(listId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ...("clientId" in config && { Client: config.clientId }),
            Version: "20240417",
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[getEquivalentSecurityList] Could not parse";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getEquivalentSecurityList.js.map